"use client";

import React from "react";
import { ArrowRight, Disc3, ShieldAlert, Truck } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
const serviceCards = [{
  id: "shop",
  title: "New Tires & Tire Shop",
  description: "Browse brand-name new and quality inspected tires with fast installation.",
  link: "/TireShopLosAngelesPage",
  icon: Disc3
}, {
  id: "flat-repair",
  title: "Flat Tire Repair",
  description: "Same-day puncture inspection, bead resealing, and patch repairs.",
  link: "/ServicesPage",
  icon: ShieldAlert
}, {
  id: "mobile-service",
  title: "Mobile Tire Service",
  description: "Roadside assistance and on-site tire service wherever you are parked in LA.",
  link: "/ServicesPage",
  icon: Truck
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: "easeOut"
    }
  }
};
export default function ExploreServices() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="exploremoreservices" data-nav="light" className="relative bg-background py-16 md:py-20">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-10 flex flex-col items-start justify-between gap-4 border-b border-border pb-6 md:flex-row md:items-end">
          <div>
            <div className="mb-2 flex items-center gap-2">
              <span className="h-1.5 w-8 rounded-sm bg-primary" />
              <span className="text-xs font-semibold tracking-wider text-primary uppercase">
                Los Angeles Tire Solutions
              </span>
            </div>
            <h2 className="font-default text-2xl font-black italic tracking-tight text-foreground uppercase sm:text-3xl md:text-4xl">
              Explore More Services
            </h2>
          </div>
          <p className="max-w-md text-sm text-muted-foreground">
            Get back on the road safely with specialized automotive tire care and prompt same-day service.
          </p>
        </div>

        <motion.div variants={shouldReduceMotion ? undefined : containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {serviceCards.map((service, i) => {
          const IconComponent = service.icon;
          return <motion.div key={service.id} data-index={i} variants={shouldReduceMotion ? undefined : cardVariants} whileHover={shouldReduceMotion ? undefined : {
            y: -3
          }} className="group relative flex flex-col justify-between overflow-hidden rounded-sm border border-border border-t-2 border-t-primary bg-card p-6 shadow-sm transition-[border-color,box-shadow] duration-200 hover:border-primary/50 hover:shadow-md">
                <div>
                  <div className="mb-4 flex items-center justify-between">
                    <div className="flex size-11 items-center justify-center rounded-sm bg-accent text-accent-foreground transition-colors duration-200 group-hover:bg-primary group-hover:text-primary-foreground">
                      <IconComponent className="size-5" />
                    </div>
                    <span className="text-xs font-mono font-medium text-muted-foreground">
                      0{i + 1}
                    </span>
                  </div>

                  <h3 className="font-default text-lg font-bold tracking-tight text-card-foreground">
                    {service.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                    {service.description}
                  </p>
                </div>

                <div className="mt-6 pt-4 border-t border-border/60">
                  <Link to={service.link} className="inline-flex items-center gap-2 text-xs font-semibold tracking-wide text-primary uppercase transition-colors hover:text-foreground">
                    <span>View Service</span>
                    <ArrowRight className="size-3.5 transition-transform duration-150 group-hover:translate-x-1" />
                  </Link>
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}